const URL="https://abrightspot.org/wp-admin/admin-ajax.php";

export {URL};